// extracted by mini-css-extract-plugin
export default {"host":"style_host__feF1D","prefix":"style_prefix__4kztM","suffix":"style_suffix__uzOfe","fullName":"style_fullName__cZIBB"};